import axiosClientFSR from "../axiosClientFSR";
import axiosClientFSRUpLoadFile from "../axiosClientFSRUploadFile";

export const listObjectFSR = {
    get: (param) => {
        return axiosClientFSR.get('/object/list', {
            params: param
        })
    },
    add: (formData) => {
        return axiosClientFSRUpLoadFile.post('/object/add', formData)
    },
    delete: (id) => {
        return axiosClientFSR.delete(`/object/${id}`)
    },
    edit: (id, params, data) => {
        return axiosClientFSRUpLoadFile.put(`/object/edit/${id}${params}`,data)
    },
    getById: (id) => {
        return axiosClientFSR.get(`/object/detail/${id}`)
    }
}